import { pdf } from '@react-pdf/renderer';
import { BACKEND_SERVICE_BASE_URL } from '../../../constants'
import axios from 'axios'
// import FileSaver from 'file-saver';

const saveBlob = (blob, filename) => {
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  let url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const savePdf = async (document, filename) => {
  const blob = await pdf(document).toBlob()

  saveBlob(blob, filename);
  
  /* ----------------- CAN BE USED TO UPLOAD THEN DOWNLOAD FILE FROM SERVER ----------------- */

  // const blob = await pdf(document).toBlob()
  // const fd = new FormData()
  // fd.append('pdf', blob, filename)

  // axios({
  //   method: 'post',
  //   url: `${BACKEND_SERVICE_BASE_URL}/api/upload`,
  //   data: fd,
  //   headers: {
  //     'Content-Type': 'multipart/form-data'
  //   }
  // }).then(async res => {
  //   const { pathToFile, fileName } = res.data
      
  //   window.open(`${BACKEND_SERVICE_BASE_URL}/api/download?path=${pathToFile}&filename=${fileName}`)
   
  // }).catch(err => err)

}

export const savePdfIos = async (document, filename) => {
  // const blob = await pdf(document).toBlob()

  // FileSaver.saveAs(blob, filename)
  
  /* ----------------- CAN BE USED TO UPLOAD THEN DOWNLOAD FILE FROM SERVER ----------------- */

  const blob = await pdf(document).toBlob()
  const fd = new FormData()
  fd.append('pdf', blob, filename)
  const windowReference = window.open()


  axios({
    method: 'post',
    url: `${BACKEND_SERVICE_BASE_URL}/api/upload`,
    data: fd,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(async res => {
    const { pathToFile, fileName } = res.data
      
    // window.open(`${BACKEND_SERVICE_BASE_URL}/api/download?path=${pathToFile}&filename=${fileName}`)
    windowReference.location = `${BACKEND_SERVICE_BASE_URL}/api/download?path=${pathToFile}&filename=${fileName}`

  }).catch(err => err)
}
